window.theme.block('grid-content-image', el => {
    const images = el.querySelectorAll('.image-wrapper .image');
    const section = el;

    // Return early if no images are present
    if (!images.length) return;

    const triggerPercentage = 0.25;
    let ticking = false;

    function handleScroll() {
        const scrollTop = window.scrollY;
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const triggerPoint = window.innerHeight * triggerPercentage;

        if (scrollTop + triggerPoint >= sectionTop && scrollTop <= sectionTop + sectionHeight) {
            const progress = (scrollTop + triggerPoint - sectionTop) / sectionHeight;
            const scale = 1 + progress * 0.2;

            images.forEach(image => {
                image.style.transform = `scale(${scale})`;
            });
        } else if (scrollTop + triggerPoint < sectionTop) {
            images.forEach(image => {
                image.style.transform = `scale(1)`;
            });
        }

        ticking = false;
    }

    document.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    });
});
